"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.nestedCardTokens = void 0;
var _tokens = _interopRequireDefault(require("../../../shared/tokens/tokens"));
var nestedCardTokens = exports.nestedCardTokens = {
  font: {
    regular: _tokens.default.sky.sys.font.body[1]
  },
  colorTheme: {
    dark: {
      headerBackground: _tokens.default.sky.ref.color.coolneutral[900],
      textColor: _tokens.default.sky.ref.color.neutral[50],
      iconColor: _tokens.default.sky.ref.color.neutral[50]
    },
    medium: {
      headerBackground: _tokens.default.sky.ref.color.blue[200],
      textColor: _tokens.default.sky.ref.color.neutral[900],
      iconColor: _tokens.default.sky.ref.color.neutral[900]
    },
    light: {
      headerBackground: _tokens.default.sky.ref.color.blue[50],
      textColor: _tokens.default.sky.ref.color.neutral[900],
      iconColor: _tokens.default.sky.ref.color.neutral[900]
    }
  },
  padding: {
    wrapper: _tokens.default.sky.sys.spacing[100],
    header: _tokens.default.sky.sys.spacing[300],
    content: _tokens.default.sky.sys.spacing[200],
    summary: _tokens.default.sky.sys.spacing[400],
    wrapperBottomUnexpanded: _tokens.default.sky.ref.unit[50]
  },
  spacing: {
    contextMenuPlaceholder: _tokens.default.sky.sys.spacing[600]
  },
  margin: {
    summaryBottom: _tokens.default.sky.ref.unit[50]
  },
  color: {
    subcontainerBackground: _tokens.default.sky.ref.color.neutral[50]
  },
  borderRadius: _tokens.default.sky.sys.size.borderradius[2]
};